import React, { useContext, useState, useEffect } from 'react';
import { Modal, Form } from 'react-bootstrap';
import toast from 'react-hot-toast';

import { DataContext } from '../../../../../init/getData';
import { Space, Table, Tag, Button } from 'antd';

import { numberFormatter } from '../../../../../components/formatters/numberFormatter';
import Cart from '../../../../../retailTab/pos/items/cart';




const LoadStockJv = (props) => {

    const { setTransactions, journalVoucher, selectedCurrency, cart, totalCost } = props;

    const { api, userData, settingData, mainCurrency, secondaryCurrency, rateMainToSecondaryCurrency, rateToMainCurrency } = useContext(DataContext);
    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role;



    // load Transactions
    useEffect(() => {
        loadJV();
    }, [journalVoucher, cart]);

    const accountId = journalVoucher?.accountId;
    const warehouseId = journalVoucher?.warehouseId;
    const openingStockAccountId = settingData.openingStockAccountId;
    const isDebit = journalVoucher.isDebit;

    const downPayment = journalVoucher.downPayment;

    const rate = selectedCurrency?.rate;
    const currencyId = selectedCurrency?.id;
    const total = journalVoucher?.debit;

    const loadJV = () => {

        let updatedTransactions = [];

        updatedTransactions = loadStockTransaction(updatedTransactions, true);
        updatedTransactions = loadAcountTransaction(updatedTransactions, false, openingStockAccountId, 'Opening', totalCost);

        setTransactions(updatedTransactions);

    }

    const loadStockTransaction = (updatedTransactions, isDebit) => {

        for (const item of cart) {

            let accountId = item.accountId;

            const debit = isDebit ? item.totalCost : 0;
            const credit = !isDebit ? item.totalCost : 0;

            const totalDebit = rateToMainCurrency(selectedCurrency, debit);
            const totalCredit = rateToMainCurrency(selectedCurrency, credit);

            const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
            const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);


            // Check if the account already exists in the transactions
            const cartAccountExists = updatedTransactions.find(entry => entry.accountId === accountId && entry.type == 'Stock' && entry.isDebit == isDebit);

            if (cartAccountExists) {
                if (isDebit) {
                    cartAccountExists.debit = parseFloat(cartAccountExists.debit) + parseFloat(debit);
                    cartAccountExists.totalDebit = cartAccountExists.totalDebit + parseFloat(totalDebit);
                    cartAccountExists.secondaryTotalDebit = cartAccountExists.secondaryTotalDebit + parseFloat(secondaryTotalDebit);

                } else {
                    cartAccountExists.credit = parseFloat(cartAccountExists.credit) + parseFloat(credit);
                    cartAccountExists.totalCredit = parseFloat(cartAccountExists.totalCredit) + parseFloat(totalCredit);
                    cartAccountExists.secondaryTotalCredit = cartAccountExists.secondaryTotalCredit + parseFloat(secondaryTotalCredit);
                }
            } else {
                // If the account doesn't exist, create a new transaction
                const cartTransaction = {
                    type: 'Stock',
                    accountId: accountId,
                    isDebit: isDebit,
                    details: '',
                    debit: debit,
                    credit: credit,
                    totalDebit: totalDebit,
                    totalCredit: totalCredit,
                    secondaryTotalDebit: secondaryTotalDebit,
                    secondaryTotalCredit: secondaryTotalCredit,
                    rate: rate,
                    warehouseId: warehouseId,
                    currencyId: currencyId,
                    haveCart: true,
                };

                // Add the new transaction to the updatedTransactions array
                updatedTransactions.push(cartTransaction);
            }

        }

        // Finally, return updated
        return updatedTransactions;
    };


    const loadAcountTransaction = (updatedTransactions, isDebit, accountId, type, total) => {


        const debit = isDebit ? total : 0;
        const credit = !isDebit ? total : 0;

        const totalDebit = rateToMainCurrency(selectedCurrency, debit);
        const totalCredit = rateToMainCurrency(selectedCurrency, credit);

        const secondaryTotalDebit = rateMainToSecondaryCurrency(totalDebit);
        const secondaryTotalCredit = rateMainToSecondaryCurrency(totalCredit);

        const accountTransaction = {
            type: type,
            accountId: accountId,
            details: '',
            isDebit: isDebit,
            debit: debit,
            credit: credit,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalDebit: secondaryTotalDebit,
            secondaryTotalCredit: secondaryTotalCredit,
            currencyId: currencyId,
            rate: rate,
        }

        updatedTransactions.push(accountTransaction);

        return updatedTransactions;
    }


    return (


        <></>

    )
}


export default LoadStockJv;